import { Link as RouterLink } from "react-router-dom";
import {
  Button,
  Card,
  CardActionArea,
  CardContent,
  Stack,
  CardMedia,
  Typography,
} from "@mui/material";
import placeholderImage from "../../../../@lib/images/person-placeholder.jpg";
import { useAuthSession } from "../../../../components/AuthSessionProvider";
import {
  ConditionalRenderer,
  useLanguageTranslator,
} from "../../../../components";
import { baseURL } from "../../../../utils/constants";
import { styled } from "@mui/material/styles";

const CardActionButton = styled(Button)(({ theme }) => ({
  textTransform: "uppercase",
  borderRadius: 100,
  paddingTop: theme.spacing(0.25),
  paddingBottom: theme.spacing(0.25),
  fontSize: 12,
  flex: 1,
  color: "#ffffff",
}));

function PeopleListCard({
  elem,
  isPrivate,
  handleDelete = () => {},
  editPath = "",
}: any) {
  const { user } = useAuthSession();
  const { translator } = useLanguageTranslator();
  const isLoggedIn = !!user;

  return (
    <Card sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
      <CardActionArea
        component={RouterLink}
        to={`/personDetail?id=${elem.id}`}
        sx={{ flexBasis: 150, minWidth: 150, maxWidth: 150 }}
      >
        <CardMedia
          component="img"
          sx={{ p: 2, borderRadius: 4, width: "150px" }}
          height={150}
          image={
            elem?.picture?.source
              ? `${baseURL}${elem?.picture?.source}`
              : placeholderImage
          }
          alt="policy papers"
        />
      </CardActionArea>
      <CardContent
        component={Stack}
        sx={{ flexGrow: 1 }}
        justifyContent="space-between"
        alignItems="flex-start"
        gap={2}
      >
        <div>
          <Typography variant="h6">
            {elem?.firstname} {elem?.lastname}
          </Typography>
          <Typography variant="body2">{elem?.country?.name}</Typography>
          <Typography component="p" variant="caption">
            {elem.title}
          </Typography>
        </div>
      </CardContent>
      <ConditionalRenderer
        condition={
          isPrivate && isLoggedIn && elem?.status?.toLowerCase() !== "approved"
        }
      >
        <Stack flexBasis="15%" gap={2} minWidth={200} maxWidth={200}>
          <CardActionButton
            size="small"
            variant="contained"
            // disabled={loading}
            href={editPath}
            sx={{
              padding: "4px 10px",
              fontSize: "0.8125rem",
              borderRadius: "8px",
            }}
          >
            {translator("generic.EDIT")}
          </CardActionButton>
          <Button
            // disabled={loading}
            size="small"
            variant="contained"
            color="error"
            onClick={handleDelete}
          >
            {translator("generic.DELETE")}
          </Button>
        </Stack>
      </ConditionalRenderer>
    </Card>
  );
}

export { PeopleListCard };
